const resolveDefaultBaseUrl = (hostname) => {
  if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
    return 'http://localhost:9800';
  }

  if (hostname.startsWith('preview-')) {
    return 'https://preview-api.mindcloud.co';
  }

  if (hostname.includes('staging')) {
    return 'https://api-staging.mindcloud.co';
  }

  return 'https://api.mindcloud.co';
};

const getPlatformApiBaseUrl = ({ configuredBaseUrl = import.meta.env.VITE_API_BASE_URL, hostname = window.location.hostname, trailingSlash = true } = {}) => {
  const baseUrl = (configuredBaseUrl || resolveDefaultBaseUrl(hostname)).replace(/\/+$/, '');

  return trailingSlash ? `${baseUrl}/` : baseUrl;
};

export default getPlatformApiBaseUrl;
